// src/utils/auth0.js
let auth0Instance = null;

export function setAuth0Instance(instance) {
  auth0Instance = instance;
}

export async function getAccessToken() {
  if (!auth0Instance?.getAccessTokenSilently) {
    console.warn("Auth0 instance not initialized yet");
    return null;
  }
  try {
    return await auth0Instance.getAccessTokenSilently();
  } catch (error) {
    console.error("Failed to get Auth0 token:", error);
    return null;
  }
}
